var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2ArmDisarmButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 19.66l3.18 2.43L19 43.21V63h-4V12h4v24.63l13-16.97zm27 18.28v-.38c-.08-7.22-2.52-13.58-6.37-17.22L60 13H43v17l6.8-6.8C52.88 26 55 31.65 55 37.75c0 6.27-2.24 12-5.47 14.81L43 46v17h17l-7.6-7.6c3.97-3.6 6.51-10.08 6.6-17.46z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Arm_disarm_button.30ea8be3.svg";
export { SvgJ2ArmDisarmButton as ReactComponent };